/* Pick Your Own Harvest Basket — picker logic (theme asset fb-picker.js) */
(function(){
  var COLLECTION = 'fruit-basket-fall-picks';
  var MAX_PICK = 6;
  var SECTIONS = [
    { name:'The Corn Stand', titles:[
      'Sweet Maíz Medium Beeswax Corn Candle',
      'Mulberry Medium Beeswax Corn Candle',
      'Maple Leaf Medium Beeswax Corn Candle',
      'Blackberry Medium Beeswax Corn Candle',
      'Sweet Maíz Tall Beeswax Corn Candle',
      'Maple Leaf Tall Beeswax Corn Candle',
      'Blackberry Tall Beeswax Corn Candle',
      'Mulberry Tall Beeswax Corn Candle'
    ]},
    { name:'The Pumpkin Patch', titles:[
      'Small Pumpkin Beeswax Candle',
      'Large Pumpkin Beeswax Candle',
      'Butternut Squash Pumpkin Beeswax Candle',
      'Mulberry Small Pumpkin Beeswax Candle',
      'Mulberry Large Pumpkin Beeswax Candle',
      'Mulberry Butternut Squash Pumpkin Beeswax Candle',
      'Blackberry Small Pumpkin Beeswax Candle',
      'Blackberry Large Pumpkin Beeswax Candle',
      'Blackberry Butternut Squash Pumpkin Beeswax Candle',
      'Maple Leaf Small Pumpkin Beeswax Candle',
      'Maple Leaf Large Pumpkin Beeswax Candle',
      'Maple Leaf Butternut Squash Pumpkin Beeswax Candle'
    ]},
    { name:'The Orchard', titles:[
      'Bartlett Green Pear Beeswax Candle',
      'Bosc Pear Beeswax Candle',
      'Red Delicious Apple Beeswax Candle',
      'Green Apple Beeswax Candle',
      'Fig Beeswax Candle',
      'Green Fig Beeswax Tealight Candles — Set of 2'
    ]},
    { name:'The Veggie Table', titles:[
      'Asparagus Beeswax Taper Candles — Set of 2',
      'Purple Asparagus Beeswax Taper Candles — Set of 2',
      'Celery Beeswax Taper Candles — Set of 2',
      'Carrot Beeswax Taper Candles — Set of 2',
      "8'' Purple Carrot Beeswax Taper Candles — Set of 2",
      "8'' Carrot Beeswax Taper Candles — Set of 2"
    ]},
    { name:'Berry Birthday Corner', titles:[
      'Beeswax Mixed Berry Birthday Candles',
      'Raspberry Beeswax Birthday Candles',
      'Strawberry Beeswax Birthday Candles',
      'Cherry Beeswax Birthday Candles',
      'Blackberry Beeswax Birthday Candles',
      'Pink Blackberry Beeswax Birthday Candles'
    ]}
  ];
  var products = [];
  var selected = [];

  var BASKET_SVG =
    '<svg viewBox="0 0 76 46" aria-hidden="true">' +
    '<path d="M6 16 H70 L61 42 H15 Z" fill="#e8c98f" stroke="#2a221a" stroke-width="2.5" stroke-linejoin="round"/>' +
    '<rect x="6" y="11" width="64" height="8" rx="4" fill="#d9b47c" stroke="#2a221a" stroke-width="2.5"/>' +
    '<line x1="22" y1="19" x2="26" y2="42" stroke="#2a221a" stroke-width="1.5" opacity=".4"/>' +
    '<line x1="38" y1="19" x2="38" y2="42" stroke="#2a221a" stroke-width="1.5" opacity=".4"/>' +
    '<line x1="54" y1="19" x2="50" y2="42" stroke="#2a221a" stroke-width="1.5" opacity=".4"/>' +
    '<line x1="11" y1="30" x2="65" y2="30" stroke="#2a221a" stroke-width="1.5" opacity=".4"/>' +
    '</svg>';
  function money(cents){ return '$' + (cents/100).toFixed(2).replace(/\.00$/,''); }
  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }
  function shortName(title){
    return String(title)
      .replace(/\bBeeswax\b/gi,'')
      .replace(/\bCandles?\b/gi,'')
      .replace(/\s{2,}/g,' ')
      .replace(/\s+—\s*$/,'')
      .trim();
  }
  function byId(id){
    for(var i=0;i<products.length;i++){ if(products[i].id===id) return products[i]; }
    return null;
  }
  function load(){
    return fetch('/collections/'+COLLECTION+'/products.json?limit=250')
      .then(function(r){ if(!r.ok) throw new Error('bad response'); return r.json(); })
      .then(function(d){
        var byTitle = {};
        (d.products||[]).forEach(function(p){ byTitle[p.title] = p; });
        SECTIONS.forEach(function(sec, si){
          sec.titles.forEach(function(title){
            var p = byTitle[title];
            if(!p) return;
            var v = (p.variants||[]).find(function(x){ return x.available; });
            if(!v) return;
            products.push({
              id: v.id,
              title: p.title,
              price: Math.round(parseFloat(v.price)*100),
              img: (p.images && p.images[0] && p.images[0].src) || '',
              section: si
            });
          });
        });
      });
  }
  function render(){
    var wrap = document.getElementById('fb-sections');
    if(!products.length){
      wrap.innerHTML = '<div class="fb-error">Hmm, the farm stand is closed right now &mdash; check back soon!</div>';
      return;
    }
    wrap.innerHTML = '';
    SECTIONS.forEach(function(sec, si){
      var items = products.filter(function(p){ return p.section === si; });
      if(!items.length) return;
      var stall = document.createElement('div');
      stall.className = 'fb-stall';
      var h = document.createElement('h2');
      h.className = 'fb-sec';
      var sign = document.createElement('span');
      sign.textContent = sec.name;
      h.appendChild(sign);
      // Bee accent beside the stall sign (falls back to the bare sign).
      stall.appendChild(beeSignRow(si, h) || h);
      var grid = document.createElement('div');
      grid.className = 'fb-grid';
      items.forEach(function(p){
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'fb-card';
        card.setAttribute('data-id', p.id);
        card.setAttribute('aria-pressed','false');
        card.innerHTML =
          '<span class="fb-check">✓</span>' +
          '<span class="fb-card-price">'+money(p.price)+'</span>' +
          
          (p.img ? '<img src="'+p.img+'" alt="" loading="lazy">' : '<div style="aspect-ratio:1/1;background:#f3e9d2"></div>') +
          '<span class="fb-card-body"><span class="fb-card-title">'+escapeHtml(p.title)+'</span>' +
          '<span class="fb-card-foot">' +
          '<span class="fb-stepper" hidden><span class="fb-dec" role="button" tabindex="0" aria-label="Remove one of this candle">−</span>' +
          '<span class="fb-qty" aria-hidden="true">×1</span>' +
          '<span class="fb-inc" role="button" tabindex="0" aria-label="Add one more of this candle">+</span></span></span></span>';
        card.addEventListener('click', function(e){
          var t = (e.target && e.target.closest) ? e.target.closest('.fb-dec,.fb-inc') : null;
          if(t){ toggle(p.id, card, t.classList.contains('fb-dec')); return; }
          toggle(p.id, card, false);
        });
        card.addEventListener('keydown', function(e){
          var t = e.target;
          if(t && t.classList && (e.key === 'Enter' || e.key === ' ') &&
             (t.classList.contains('fb-dec') || t.classList.contains('fb-inc'))){
            e.preventDefault();
            toggle(p.id, card, t.classList.contains('fb-dec'));
          }
        });
        grid.appendChild(card);
      });
      stall.appendChild(grid);
      wrap.appendChild(stall);
    });
    update();
  }
  function wiggle(el){
    if(el && el.animate){
      el.animate(
        [{transform:'rotate(0deg)'},{transform:'rotate(-2.5deg)'},{transform:'rotate(2deg)'},{transform:'rotate(-1deg)'},{transform:'rotate(0deg)'}],
        {duration:380, easing:'ease-in-out'}
      );
    }
  }
  function toggle(id, el, dec){
    if(dec){
      // Minus control: remove a single unit of this candle.
      var i = selected.indexOf(id);
      if(i > -1) selected.splice(i,1);
    } else {
      // Tapping a card adds another unit, up to 6 total.
      if(selected.length >= MAX_PICK) return;
      selected.push(id);
      wiggle(el);
    }
    update();
  }

  // Units of one variant currently in the basket.
  function countOf(id){
    var c = 0;
    for(var i=0;i<selected.length;i++){ if(selected[i] === id) c++; }
    return c;
  }
  // Illustration icons for the basket thumbnails (uploaded as theme assets).
  // Base URL is derived from the injected bee URLs so it tracks the live theme.
  var ICON_BASE = (window.FB_BEE_URLS && window.FB_BEE_URLS.bee3 ? window.FB_BEE_URLS.bee3 : '').replace(/fb_bee3\.png.*$/, '');
  var ICONS = {
    pumpkin: ICON_BASE + 'fb_icon_pumpkin.png?v=3',
    squash: ICON_BASE + 'fb_icon_squash.png?v=3',
    pear: ICON_BASE + 'fb_icon_pear.png?v=2',
    apple: ICON_BASE + 'fb_icon_apple.png?v=2',
    corn: ICON_BASE + 'fb_icon_corn.png?v=2',
    carrot: ICON_BASE + 'fb_icon_carrot.png?v=2',
    asparagus: ICON_BASE + 'fb_icon_asparagus.png?v=2',
    celery: ICON_BASE + 'fb_icon_celery.png?v=2',
    strawberry: ICON_BASE + 'fb_icon_strawberry.png?v=2',
    blackberry: ICON_BASE + 'fb_icon_blackberry.png?v=2',
    cherry: ICON_BASE + 'fb_icon_cherry.png?v=2',
    fig: ICON_BASE + 'fb_icon_fig.png?v=3'
  };
  function iconFor(p){
    var t = (p.title || '').toLowerCase();
    if(/butternut/.test(t)) return 'squash';
  if(/pumpkin|squash/.test(t)) return 'pumpkin';
    if(/pear/.test(t)) return 'pear';
    if(/apple/.test(t)) return 'apple';
    if(/fig/.test(t)) return 'fig';
    if(/celery/.test(t)) return 'celery';
    if(/asparagus/.test(t)) return 'asparagus';
    if(/corn|maíz/.test(t)) return 'corn';
    if(/carrot/.test(t)) return 'carrot';
    if(/strawberry/.test(t)) return 'strawberry';
    if(/cherry/.test(t)) return 'cherry';
    if(/berry/.test(t)) return 'blackberry';
    return null;
  }

  // Bee accent beside each stall sign; bee artwork comes from the page section.
  var BEE_ORDER = [
    {k:'left', r:'-8deg', s:'left'},
    {k:'right', r:'7deg', s:'right'},
    {k:'bee3', r:'-5deg', s:'left'},
    {k:'left', r:'10deg', s:'right'},
    {k:'bee5', r:'-12deg', s:'left'}
  ];
  function beeSignRow(si, h){
    var B = window.FB_BEE_URLS;
    var cfg = BEE_ORDER[si % BEE_ORDER.length];
    if(!B || !cfg || !B[cfg.k]) return null;
    var row = document.createElement('div');
    row.className = 'fb-bee-sign';
    row.setAttribute('aria-hidden','true');
    var im = document.createElement('img');
    im.src = B[cfg.k];
    im.alt = '';
    im.setAttribute('aria-hidden','true');
    im.style.cssText = 'transform:rotate('+cfg.r+');' + (cfg.s === 'left' ? 'margin-right:-6px;' : 'margin-left:-6px;');
    if(cfg.s === 'left'){ row.appendChild(im); row.appendChild(h); }
    else { row.appendChild(h); row.appendChild(im); }
    return row;
  }
  function cheapestPicked(){
    var picked = selected.map(byId).filter(Boolean);
    if(!picked.length) return null;
    return picked.reduce(function(a,b){ return a.price <= b.price ? a : b; });
  }
  function update(){
    var cards = document.querySelectorAll('.fb-card');
    cards.forEach(function(card){
      var id = parseInt(card.getAttribute('data-id'),10);
      var qty = countOf(id);
      card.classList.toggle('selected', qty > 0);
      card.setAttribute('aria-pressed', qty > 0 ? 'true' : 'false');
      var stepper = card.querySelector('.fb-stepper');
      if(stepper) stepper.hidden = qty === 0;
      var qtyEl = card.querySelector('.fb-qty');
      if(qtyEl && qty > 0) qtyEl.textContent = '×' + qty;
    });
    // Basket thumbnails: illustration icons for the picks peek out of the basket.
    var picksEl = document.getElementById('fb-basket-picks');
    if(picksEl){
      picksEl.innerHTML = selected.map(function(id){
        var p = byId(id);
        if(!p) return '';
        var ic = iconFor(p);
        var src = (ic && ICON_BASE && ICONS[ic]) || p.img;
        return src ? '<img src="'+src+'" alt="" aria-hidden="true">' : '';
      }).join('');
    }
    var n = selected.length;
    document.getElementById('fb-count').textContent = n + ' of ' + MAX_PICK + ' in your basket';
    document.getElementById('fb-fill').style.width = (n/MAX_PICK*100) + '%';
    var status = document.getElementById('fb-status');
    var btn = document.getElementById('fb-add');
    if(n < MAX_PICK){

      status.style.display = 'none';
      btn.disabled = true;
      btn.textContent = 'Fill your basket';
    } else {
      var picked = selected.map(byId).filter(Boolean);
      var total = picked.reduce(function(s,p){ return s+p.price; }, 0);
      var cheap = cheapestPicked();
      var cheapName = cheap ? escapeHtml(shortName(cheap.title)) : 'freebie';
      status.style.display = '';
      status.innerHTML = 'Basket&rsquo;s full! The <strong>'+cheapName+'</strong> is on the house &middot; you pay <strong>'+money(total-cheap.price)+'</strong> &middot; you save <strong>'+money(cheap.price)+'</strong>';
      btn.disabled = false;
      btn.textContent = 'Ring me up · ' + money(total-cheap.price);
    }
  }
  function luckyDip(){
    if(!products.length) return;
    var pool = products.slice();
    selected = [];
    while(selected.length < MAX_PICK && pool.length){
      var idx = Math.floor(Math.random()*pool.length);
      selected.push(pool.splice(idx,1)[0].id);
    }
    update();
  }
  function addToCart(){
    var btn = document.getElementById('fb-add');
    btn.disabled = true;
    btn.innerHTML = '<span class="fb-spinner" aria-hidden="true"></span>Packing your basket…';
    var queue = selected.slice();
    function next(){
      if(!queue.length){ window.location.href = '/cart'; return; }
      var id = queue.shift();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id:id, quantity:1})
      }).then(function(r){

        if(!r.ok) throw new Error('add failed');
        next();
      }).catch(function(){
        update();
        document.getElementById('fb-status').innerHTML = 'Hmm, something hiccupped &mdash; tap again to retry';
      });
    }
    next();
  }
  // Static chrome injected around the picker: the progress tracker moves into the
  // bottom bar (keeps the top of the page clear for the menu), plus the lucky-dip button.
  function injectChrome(){
    var prog = document.querySelector('.fb-progress');
    var ctaInner = document.querySelector('.fb-cta-inner');
    if(prog && ctaInner && !document.getElementById('fb-cta-progress')){
      var tracker = document.createElement('div');
      tracker.className = 'fb-cta-progress';
      tracker.id = 'fb-cta-progress';
      var inner = prog.querySelector('.fb-progress-inner');
      var text = document.createElement('div');
      text.className = 'fb-progress-text';
      if(inner){ while(inner.firstChild){ text.appendChild(inner.firstChild); } }
      var basket = document.createElement('div');
      basket.className = 'fb-basket';
      basket.id = 'fb-basket';
      basket.setAttribute('aria-hidden','true');
      basket.innerHTML = '<div class="fb-basket-picks" id="fb-basket-picks"></div>' + BASKET_SVG;
      tracker.appendChild(basket);
      tracker.appendChild(text);
      ctaInner.insertBefore(tracker, ctaInner.firstChild);
      prog.parentNode.removeChild(prog);
    }
    var heroRow = document.querySelector('.fb-welcome') || document.querySelector('.fb-steps');
    if(heroRow && !document.getElementById('fb-lucky')){
      var lucky = document.createElement('button');
      lucky.type = 'button';
      lucky.id = 'fb-lucky';
      lucky.className = 'fb-lucky';
      lucky.textContent = 'Not sure? Surprise me';
      lucky.addEventListener('click', luckyDip);
      heroRow.parentNode.insertBefore(lucky, heroRow.nextSibling);
    }
  }
  injectChrome();
  document.getElementById('fb-add').addEventListener('click', addToCart);
  load().then(render).catch(function(){
    document.getElementById('fb-sections').innerHTML = '<div class="fb-error">Hmm, the farm stand is closed right now &mdash; check back soon!</div>';
  });
})();